import { render, staticRenderFns } from "./DevStat.vue?vue&type=template&id=9ac70aee&scoped=true&"
import script from "./DevStat.vue?vue&type=script&lang=js&"
export * from "./DevStat.vue?vue&type=script&lang=js&"
import style0 from "./DevStat.vue?vue&type=style&index=0&id=9ac70aee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac70aee",
  null
  
)

export default component.exports